import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c8f064fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "jf-nodata" }
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: _ctx.imgSrc,
      alt: "",
      class: "jf-nodata__img"
    }, null, 8, _hoisted_2),
    _createElementVNode("span", {
      class: "jf-nodata__text",
      style: _normalizeStyle({ color: _ctx.isDark ? 'rgba(255,255,255,0.35)' : '#999999' })
    }, "暂无数据", 4)
  ]))
}